import { Modal } from 'react-bootstrap';
import { Typography } from 'app/components';
import { i18n, i18nTemplate } from 'app/utils/i18n';

import './RemoveModal.scss';

interface RemoveModalProps {
  show: boolean;
  taxonomyName?: string;
  tagCount?: number;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const RemoveModal = ({ show, taxonomyName, tagCount = 0, isLoading, onClose, onConfirm }: RemoveModalProps) => {
  return (
    <Modal show={show} centered dialogClassName="remove-modal-dialog" contentClassName="remove-modal">
      <Modal.Body className="remove-modal__content">
        <Typography variant="body-8" fontWeight="semibold">
          {i18n('tag.taxonomy.remove.title')}
        </Typography>

        {tagCount > 0 ? (
          <Typography variant="body-7">{i18nTemplate('tag.taxonomy.remove.cascade.description', { taxonomyName, tagCount })}</Typography>
        ) : (
          <Typography variant="body-7">{i18n('tag.taxonomy.remove.description')}</Typography>
        )}

        <div className="remove-modal__actions">
          <button className="btn btn-primary" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? i18n('common.loading') : tagCount > 0 ? i18n('tag.taxonomy.remove.cascade.confirm') : i18n('tag.remove.confirm')}
          </button>

          <button className="btn btn-secondary" onClick={onClose} disabled={isLoading}>
            {i18n('common.cancel')}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
